import { Store } from '@tanstack/react-store';

type NavigationState = {
  lastUrl: string | null;
};

const initialState: NavigationState = {
  lastUrl: null,
};

export const navigationStore = new Store<NavigationState>(initialState);

export function setLastUrl(url: string) {
  navigationStore.setState((state) => ({
    ...state,
    lastUrl: url,
  }));
}
